import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioviewComponent } from './inicioview/inicioview.component';

const routes: Routes = [
  {
    path: '',
    component: InicioviewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InicioRoutingModule {}
